<table class="border-separate border-spacing-y-3 border-spacing-x-6 -mx-6">
  <thead>
  <tr>
    @for (weekday of weekdays; track weekday) {
      <th>{{ WeekdayLabels[weekday] }}</th>
    }
  </tr>
  </thead>
  <tbody>
  <tr>
    @for (weekday of weekdays; track weekday) {
      <td class="align-top">
        <div class="flex flex-col">
          @for (event of events_grouped[weekday]; track event) {
            <location-weekday-event-view [event]="event"
                                         [verdict]="verdictOf(event)"></location-weekday-event-view>
          }
        </div>
      </td>
    }
  </tr>
  </tbody>
</table>
